import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"


import { useRtfix } from '@/store'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: ['goods'],
  setup(__props) {

const route = useRoute()
const query = route.query
// 商品链接附带参数
const onePsale = query.isOnePsale === 'true' ? { tab: 2 } : null



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return ((!__props.goods.productType || __props.goods.productType === 1) && __props.goods.productCode)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (__props.goods.livePriceFlag === 1)
          ? (_openBlock(), _createBlock(_component_router_link, _mergeProps({
              key: 0,
              to: _unref(useRtfix)('goods', { params: { id: __props.goods.productCode }, query: { ..._unref(onePsale), activityId: __props.goods.livePriceFlag === 1 ? '1' : ''} })
            }, _ctx.$attrs, { target: "_blank" }), {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 16, ["to"]))
          : (_openBlock(), _createBlock(_component_router_link, _mergeProps({
              key: 1,
              to: _unref(useRtfix)('goods', { params: { id: __props.goods.productCode },query: _unref(onePsale) })
            }, _ctx.$attrs, { target: "_blank" }), {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 16, ["to"]))
      ], 64))
    : _renderSlot(_ctx.$slots, "default", _normalizeProps(_mergeProps({ key: 1 }, _ctx.$attrs)))
}
}

})